export default "__VITE_ASSET__DFrBeUop__"